import { ColumnLayout, ExpandableSection, FormField, Input, Multiselect, Textarea } from '@amzn/awsui-components-react';
import React from 'react';

interface ShowRegistrationRecordProps {
  registrationRecord: any;
  formatDate: (date: Date) => string;
  createLabelValueList: (items: any[]) => Array<{ label: string; value: string }>;
  customHelpPanel: (content: string) => React.ReactNode;
  CONSTANTS: any;
}

export const ShowRegistrationRecord = ({
  registrationRecord,
  formatDate,
  createLabelValueList,
  customHelpPanel,
  CONSTANTS,
}: ShowRegistrationRecordProps) => {
  return (
    <div className="display-registration-record" style={{ backgroundColor: 'whitesmoke' }}>
      <ExpandableSection headerText="Registration Details" variant="container" defaultExpanded>
        <ColumnLayout columns={2}>
          <FormField label="Registration Number">
            <Input value={registrationRecord.registrationNumber!} disabled />
          </FormField>
          <FormField />
          <FormField label="ATP Calculation" info={customHelpPanel(CONSTANTS.FIELDS_INFO.ATP_CALCULATION)}>
            <Input value={String(registrationRecord.atpCalculationFlag)} disabled />
          </FormField>
          <FormField label="Entered Currency" info={customHelpPanel(CONSTANTS.FIELDS_INFO.CURRENCY)}>
            <Input value={registrationRecord.currency ?? ''} disabled />
          </FormField>
          <FormField label="Provider Company Code" info={customHelpPanel(CONSTANTS.FIELDS_INFO.PROVIDER_COMPANY_CODE)}>
            <Input value={registrationRecord.providerCompanyCode} disabled />
          </FormField>
          <FormField
            label="Recipient Company Code"
            info={customHelpPanel(CONSTANTS.FIELDS_INFO.RECIPIENT_COMPANY_CODE)}
          >
            <Input value={registrationRecord.recipientCompanyCode} disabled />
          </FormField>
          <FormField label="Provider Entity Name">
            <Input value={registrationRecord.providerEntityName ?? ''} disabled />
          </FormField>
          <FormField label="Recipient Entity Name">
            <Input value={registrationRecord.recipientEntityName ?? ''} disabled />
          </FormField>
          <FormField label="Provider Jurisdiction">
            <Input value={registrationRecord.providerJurisdiction ?? ''} disabled />
          </FormField>
          <FormField label="Recipient Jurisdiction">
            <Input value={registrationRecord.recipientJurisdiction ?? ''} disabled />
          </FormField>
          <FormField label="Effective Start Date" info={customHelpPanel(CONSTANTS.FIELDS_INFO.EFFECTIVE_FROM_DATE)}>
            <Input
              value={
                registrationRecord.effectiveFromDate ? formatDate(new Date(registrationRecord.effectiveFromDate)) : ''
              }
              disabled
            />
          </FormField>
          <FormField label="Effective End Date" info={customHelpPanel(CONSTANTS.FIELDS_INFO.EFFECTIVE_TO_DATE)}>
            <Input
              value={registrationRecord.effectiveToDate ? formatDate(new Date(registrationRecord.effectiveToDate)) : ''}
              disabled
            />
          </FormField>
          <FormField label="Workbook Name" info={customHelpPanel(CONSTANTS.FIELDS_INFO.WORKBOOK_NAME)}>
            <Input value={registrationRecord.workbookName ?? ''} disabled />
          </FormField>
          <FormField label="Payment Terms" info={customHelpPanel(CONSTANTS.FIELDS_INFO.PAYMENT_TERMS)}>
            <Input value={registrationRecord.paymentTerms ?? ''} disabled />
          </FormField>
          <FormField label="INBD" info={customHelpPanel(CONSTANTS.FIELDS_INFO.BEAT)}>
            <Input value={registrationRecord.beat === 'INBD' ? 'Yes' : 'No'} disabled />
          </FormField>
          <FormField />
          <FormField label="Description of Transaction" info={customHelpPanel(CONSTANTS.FIELDS_INFO.DESCRIPTION)}>
            <Textarea value={registrationRecord.description ?? ''} disabled />
          </FormField>
          <FormField label="Comments" info={customHelpPanel(CONSTANTS.FIELDS_INFO.COMMENTS)}>
            <Textarea value={registrationRecord.comments ?? ''} disabled />
          </FormField>
          <FormField label="Provider IC BS Account">
            <Input value={registrationRecord.providerIcBsAccount ?? ''} disabled />
          </FormField>
          <FormField label="Recipient IC BS Account">
            <Input value={registrationRecord.recipientIcBsAccount ?? ''} disabled />
          </FormField>
          <FormField
            label="Provider Offset Accounts"
            info={customHelpPanel(CONSTANTS.FIELDS_INFO.RECIPIENT_GL_ACCOUNTS)}
          >
            <Multiselect selectedOptions={createLabelValueList(registrationRecord.providerPlAccounts ?? [])} disabled />
          </FormField>
          <FormField
            label="Recipient Offset Accounts"
            info={customHelpPanel(CONSTANTS.FIELDS_INFO.RECIPIENT_GL_ACCOUNTS)}
          >
            <Multiselect
              selectedOptions={createLabelValueList(registrationRecord.recipientPlAccounts ?? [])}
              disabled
            />
          </FormField>
          <FormField label="Accounting POC Alias">
            <Input value={registrationRecord.accountingPoc ?? ''} disabled />
          </FormField>
        </ColumnLayout>
      </ExpandableSection>
      <ExpandableSection headerText="Registration Record Contributors" variant="container" defaultExpanded>
        <ColumnLayout columns={2}>
          <FormField label="Created By">
            <Input value={registrationRecord.createdBy} disabled />
          </FormField>
          <FormField />
          <FormField label="Last Updated By Accounting User">
            <Input value={registrationRecord.lastUpdatedByAccountingUser ?? ''} disabled />
          </FormField>
          <FormField label="Last Updated By Tax User">
            <Input value={registrationRecord.lastUpdatedByTaxUser ?? ''} disabled />
          </FormField>
          <FormField label="Created Date Time">
            <Input value={formatDate(new Date(registrationRecord.createDateTime!))} disabled />
          </FormField>
          <FormField label="Last Updated Date Time">
            <Input value={formatDate(new Date(registrationRecord.lastUpdatedDateTime!))} disabled />
          </FormField>
        </ColumnLayout>
      </ExpandableSection>
      <ExpandableSection headerText="Tax Product Details" variant="container" defaultExpanded>
        <ColumnLayout columns={2}>
          <FormField label="Provider Tax Reg Consideration">
            <Input value={String(registrationRecord.providerTaxRegConsideration)} disabled />
          </FormField>
          <FormField label="Recipient Tax Reg Consideration">
            <Input value={String(registrationRecord.recipientTaxRegConsideration)} disabled />
          </FormField>
          <FormField label="Tax Product Category Name">
            <Input value={registrationRecord.taxProductCategoryName ?? ''} disabled />
          </FormField>
          <FormField label="Tax Product Category Id">
            <Input value={registrationRecord.taxProductCategoryId ?? ''} disabled />
          </FormField>
          <FormField label="Tax Product Sub Category Name">
            <Input value={registrationRecord.taxProductName ?? ''} disabled />
          </FormField>
          <FormField label="Tax Product Sub Category Id">
            <Input value={registrationRecord.taxProductId ?? ''} disabled />
          </FormField>
          <FormField label="Export of Services" info={customHelpPanel(CONSTANTS.FIELDS_INFO.EXPORT_OF_SERVICES)}>
            <Input value={String(registrationRecord.exportOfServices)} disabled />
          </FormField>
        </ColumnLayout>
      </ExpandableSection>
    </div>
  );
};
